var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 50.6908C8.75006 48.0255 9.70033 45.4475 11.4301 43.4198C13.16 41.3921 15.556 40.0475 18.188 39.6275L18.6775 39.5477C23.0316 38.8528 27.4684 38.8528 31.8225 39.5477L32.312 39.6275C34.944 40.0475 37.34 41.3921 39.0699 43.4198C40.7997 45.4475 41.7499 48.0255 41.75 50.6908C41.75 53.0695 39.8195 55 37.4407 55H13.0592C11.9164 55 10.8203 54.546 10.0121 53.7379C9.20401 52.9297 8.75 51.8336 8.75 50.6908ZM34.875 20.625C34.875 21.889 34.626 23.1406 34.1423 24.3083C33.6586 25.4761 32.9497 26.5371 32.0559 27.4309C31.1621 28.3247 30.1011 29.0336 28.9333 29.5173C27.7656 30.001 26.514 30.25 25.25 30.25C23.986 30.25 22.7344 30.001 21.5667 29.5173C20.3989 29.0336 19.3379 28.3247 18.4441 27.4309C17.5503 26.5371 16.8414 25.4761 16.3577 24.3083C15.874 23.1406 15.625 21.889 15.625 20.625C15.625 18.0723 16.6391 15.6241 18.4441 13.8191C20.2491 12.0141 22.6973 11 25.25 11C27.8027 11 30.2509 12.0141 32.0559 13.8191C33.8609 15.6241 34.875 18.0723 34.875 20.625Z",
    stroke: "#3677AA",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.75 30.25C44.3027 30.25 46.7509 29.2359 48.5559 27.4309C50.3609 25.6259 51.375 23.1777 51.375 20.625C51.375 18.0723 50.3609 15.6241 48.5559 13.8191C46.7509 12.0141 44.3027 11 41.75 11M48.3225 55H53.9408C56.3195 55 58.25 53.0695 58.25 50.6908C58.2499 48.0255 57.2997 45.4475 55.5699 43.4198C53.84 41.3921 51.444 40.0475 48.812 39.6275C48.4855 39.5749 48.1554 39.5483 47.8247 39.5477H45.1627",
    stroke: "#3677AA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9bb7ed4a892ab2c9a6448bcd249f8f64.svg";
export { ForwardRef as ReactComponent };